import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../core'
import * as healthCheck from '../../health-check'

export const RESOURCE = {
  payload: {
    description:
      'A singular assessment or instance of a health check, containing a categorizations of questions (dimensions) and the questions (criteria) themselves.',
    dimension: healthCheck.RESOURCE.payload,
    level: 0,
    name: 'Assessment',
    partialId: PartialId.Standard.create('assessment'),
  },
  type: core.quiver.Resource.Type.DmsEntity,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEntity>

export const MODEL_ID = core.dms.models.Entity.Id.from({
  context: core.dms.models.Entity.Id.Context.from(RESOURCE.payload.dimension),
  partialId: RESOURCE.payload.partialId,
})
